export class Solucoes {
	id: number;
	descricao: string;
	usuarioAlteracao: number;
}